module.exports = __webpack_public_path__ + "img/cimb_niaga.736510fb.svg";